import { style } from '@vanilla-extract/css';

// Prefixed variable names: the page sets a plain --border-color on container
// elements, and custom properties inherit into this box.
export const transcriptBox = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: 'var(--box-padding, 24px)',
  borderWidth: 'var(--transcript-border-width, 1px)',
  borderStyle: 'var(--transcript-border-style, solid)',
  borderColor: 'var(--transcript-border-color, rgba(128, 128, 128, 0.15))',
  borderRadius: 'var(--transcript-border-radius, 16px)',
});

export const transcriptContainer = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--gap)',
  padding: 'var(--padding)',
  width: 'var(--width)',
});

export const transcriptLine = style({
  display: 'flex',
  gap: '16px',
  alignItems: 'flex-start',
  padding: 'var(--line-padding)',
  borderRadius: 'var(--line-border-radius)',
  backgroundColor: 'var(--line-background)',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  textAlign: 'left',
  border: 'none',
  width: '100%',
  fontFamily: 'inherit',

  ':hover': {
    backgroundColor: 'var(--line-hover-background)',
  },
});

export const transcriptLineActive = style({
  backgroundColor: 'var(--active-line-background)',

  ':hover': {
    backgroundColor: 'var(--active-line-background)',
  },
});

export const timestamp = style({
  flexShrink: 0,
  width: 'var(--timestamp-width)',
  color: 'var(--timestamp-color)',
  fontSize: 'var(--timestamp-font-size)',
  fontWeight: 'var(--timestamp-font-weight)',
  lineHeight: '1.5',
});

export const lineText = style({
  flex: 1,
  color: 'var(--text-color)',
  fontSize: 'var(--text-font-size)',
  fontWeight: 'var(--text-font-weight)',
  fontFamily: 'var(--text-font-family)',
  lineHeight: '1.5',
});

export const lineTextActive = style({
  fontWeight: 'var(--active-text-font-weight)',
});
